export default "__VITE_ASSET__V$TRCzlV__"